import { IonContent, IonPage } from "@ionic/react";
import React from "react";
import SparkGrid from "../SparkGrid/SparkGrid";

interface WelcomeEclipticLoadingProps {

}

const WelcomeEclipticLoading: React.FC<WelcomeEclipticLoadingProps> = ({ }) => {
    return (
        <IonPage>
            <IonContent className="bg-grid-pattern">
                <div className="relative h-full w-full">
                    <SparkGrid />
                </div>
            </IonContent>
        </IonPage>
    );
};

export default WelcomeEclipticLoading;